import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { popupParamsSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isGiveawayProductImagePopupShownSelector } from '../../../redux/giveaway-landing/selectors/giveaway-landing-popups.selectors';
import { ImagePopup as Component } from './image-popup';
const mapStateToProps = createStructuredSelector({
  open: isGiveawayProductImagePopupShownSelector,
  params: popupParamsSelector
});
const mapDispatchToProps = dispatch => bindActionCreators({
  onClose: hidePopup
}, dispatch);
export const ImagePopup = connect(mapStateToProps, mapDispatchToProps)(Component);